module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/3-4ba146a60f5a21735c5513032271d9cd.png";